import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Box, Card } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import OverlaySpinner from '../OverlaySpinner';

const useStyles = makeStyles((theme) => ({
  card: {
    border: `2px solid ${theme.palette.grey[300]}`,
    borderRadius: 10,
    padding: theme.spacing(3),
    textAlign: 'left',
    height: '100%',
  },
  error: {
    border: `2px solid ${theme.palette.error.main}`,
  },
  transparent: {
    backgroundColor: 'transparent',
  },
  nopointer: {
    pointerEvents: 'none',
  },
}));

const FlowCard = forwardRef(
  ({ children, className, error, transparent, loading }, ref) => {
    const classes = useStyles();
    return (
      <Card
        ref={ref}
        elevation={0}
        className={classnames(classes.card, className, {
          [classes.error]: error,
          [classes.transparent]: transparent,
        })}
      >
        <Box
          position="relative"
          height="100%"
          className={classnames({
            [classes.nopointer]: loading,
          })}
        >
          {loading && <OverlaySpinner />}
          {children}
        </Box>
      </Card>
    );
  }
);

FlowCard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  error: PropTypes.bool,
  transparent: PropTypes.bool,
  loading: PropTypes.bool,
};

export default FlowCard;
